import React from 'react';
import styles from './Box.module.css';
const Box = (props) => {
    return (
        <div className={`${styles.mainCon} ${props?.boxClass}`} {...props}>
            {props?.children}
        </div>
    );
}

export default Box;